const noopAnalytics = lib =>
  Object.keys(lib).reduce((acc, key) => {
    return {
      ...acc,
      [key]: () => {},
    };
  }, {});

export default noopAnalytics;
